import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { http, errMsg } from "../../lib/api";
import { TYPE_LABEL } from "../../components/extras/ExtrasShell";

const usd = (n) => (n > 0 && n < 0.0001 ? "< US$0.0001" : `US$${n >= 0.01 ? n.toFixed(2) : n.toFixed(4)}`);

const Kinds = ({ kinds }) => (
  <div className="space-y-1.5">
    {Object.entries(kinds).sort((a, b) => b[1] - a[1]).map(([k, v]) => (
      <div key={k} className="flex justify-between text-sm"><span className="text-stone-600">{k}</span><span className="ex-mono text-xs">{usd(v)}</span></div>
    ))}
  </div>
);

export default function ExtrasUsage() {
  const [d, setD] = useState(null);
  useEffect(() => { http.get("/extras/usage").then(({ data }) => setD(data)).catch((e) => toast.error(errMsg(e))); }, []);
  if (!d) return <div className="text-stone-500">Loading…</div>;
  return (
    <div data-testid="ex-usage" className="ex-fade">
      <div className="ex-eyebrow mb-3">AI spend</div>
      <h1 className="ex-display text-4xl sm:text-5xl lg:text-6xl font-semibold">What the AI has cost</h1>
      <p className="text-stone-600 mt-4 mb-10">OpenRouter credit used by the Extras studio inside Kit Studio, per product and per task.</p>
      <div className="grid md:grid-cols-2 gap-5 mb-10">
        <div className="ex-card p-6">
          <div className="ex-eyebrow mb-2">Tracked total</div>
          <div data-testid="ex-usage-total" className="ex-display text-4xl mb-5">{usd(d.total)}</div>
          {Object.keys(d.by_kind).length ? <Kinds kinds={d.by_kind} /> : <div className="text-sm text-stone-500">No AI spend yet. Products copied from Extras show their spend in the Extras app.</div>}
        </div>
        <div className="ex-card p-6">
          <div className="ex-eyebrow mb-2">OpenRouter budget</div>
          <div data-testid="ex-usage-remaining" className={`ex-display text-4xl ${d.key?.remaining < 5 ? "text-[#A2382A]" : ""}`}>{d.key?.remaining == null ? "Unknown" : d.key.remaining <= 0 ? "US$0.00 (over budget)" : `US$${d.key.remaining.toFixed(2)}`}<span className="text-base text-stone-500"> left{d.key?.limit ? ` of US$${d.key.limit.toFixed(2)}` : ""}</span></div>
          <p className="text-sm text-stone-500 mt-3">The lowest of your key limit and your OpenRouter budget, so it includes Kit Studio's kits and spending from outside the studio too. Raise it at openrouter.ai/keys.</p>
        </div>
      </div>
      <div className="space-y-3">
        {d.products.map((p) => (
          <div key={p.id} data-testid={`ex-usage-row-${p.id}`} className="ex-card p-5 grid md:grid-cols-[1fr_280px_100px] gap-4 items-start">
            <div>{p.deleted ? <span className="ex-display text-lg text-stone-400">{p.name}</span> : <Link to={`/extras/products/${p.id}`} className="ex-display text-lg hover:underline">{p.name}</Link>}
              <div className="text-xs text-stone-500">{TYPE_LABEL[p.product_type] || ""} · {p.calls} AI tasks</div></div>
            <Kinds kinds={p.kinds} />
            <div className="ex-display text-xl text-right">{usd(p.total)}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
